module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("I am a title.")]), _vm._v(" "), _c('p', [_vm._v(" written by " + _vm._s(_vm.author) + " ")]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.lists), function(list) {
    return _c('li', [_vm._v(_vm._s(list))])
  }))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addlist),
      expression: "addlist"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.addlist)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addlist = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("Add name")]), _vm._v(" "), _c('div', {
    staticClass: "heightTest"
  }, [_c('div', {
    class: {
      'active': _vm.active
    }
  }, [_vm._v("\n            事多了看风景是是快乐的叫法是打开了房间爱思考的了房间爱开始了的减肥快乐撒旦是电风扇的四大开发骄傲的离开奥斯卡的龙卷风埃里克束带结发思考的龙卷风\n        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.changeH
    }
  }, [_vm._v("Change Height")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43555014"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/firstComponent.vue
// module id = 23
// module chunks = 0